<template>
    <el-table ref="tab" v-if="tableData.length > 0 && updatePoints" height="100%" :data="tableData" style="width: 100%">
        <el-table-column fixed prop="loopName" label="回路名称" width="220">
        </el-table-column>

        <el-table-column fixed prop="date" label="日期" width="160">
        </el-table-column>

        <el-table-column :key="index" v-show="item.node" v-for="(item, index) in nodeDetails" width="440"
            :label="item.label">
            <el-table-column width="177" label="最大值">
                <el-table-column :prop="`${item.node}_max`" label="数值" width="88">
                </el-table-column>
                <el-table-column :prop="`${item.node}_max_time`" label="发生时间" width="120">
                </el-table-column>

            </el-table-column>
            <el-table-column width="177" label="最小值">
                <el-table-column :prop="`${item.node}_min`" label="数值" width="88">
                </el-table-column>
                <el-table-column :prop="`${item.node}_min_time`" label="发生时间" width="120">
                </el-table-column>

            </el-table-column>

            <el-table-column :prop="`${item.node}_mean`" width="88" label="平均值">
            </el-table-column>
        </el-table-column>
    </el-table>
    <div v-else class="row-center tip">
        <img v-if="!loading" src="../../../assets/img/not_found_data.png" alt="">
        <img v-else src="../../../assets/img/loading.png" alt="" class="loading">
    </div>
</template>

<script>
    import {
        EXTREMUM_VALUES,
        LOOP_POINT_MAX_VAL_DAY,
        LOOP_POINT_MAX_VAL_MONTH,
        LOOP_POINT_MIN_VAL_DAY,
        LOOP_POINT_MIN_VAL_MONTH,
        LOOP_POINT_MEAN_VAL_DAY,
        LOOP_POINT_MEAN_VAL_MONTH
    } from "../../../api/power"
    import {
        floatFormat
    } from "../../../util/MathUtil"
    import {
        dateFormat,
        dayEnd,
        dayStart,
        monthEnd,
        monthStart
    } from "../../../util/DateUtil"
    import exportExcel from "../../../util/excel";

    export default {
        name: "Extremum",
        props: {
            loops: Array,
            nodes: Array,
            range: String,
            date: Date,
            nodeDetails: Array
        },
        data() {
            return {
                loading: false,
                requestRes: []
            }
        },
        computed: {
            diagramStatus() {
                return this.$store.state.project.diagramStatus
            },
            tableData() {
                if (this.requestRes.length === 0) {
                    return []
                }
                let date = this.range === 'day' ? this.date.toLocaleDateString() : this.date.getFullYear() + '/' + (this
                    .date.getMonth() + 1)
                return this.loops.map(l => {
                    let obj = {
                        loopName: l.loopName,
                        date
                    }

                    this.nodes.forEach(n => {
                        this.requestRes.forEach((res, index) => {
                            try {
                                let extremum = res.data.data.extremum;

                                for (let k in extremum) {
                                    if (extremum.hasOwnProperty(k)) {
                                        var start = k.indexOf("/");
                                        var s = k.substring(start + 1);
                                        extremum[s] = extremum[k]
                                    }
                                }
                                // console.log(extremum)


                                if (index === 0) {
                                    obj[`${n}_max`] = floatFormat(extremum[
                                        `${l.subLoopUrl}_${n}`].max, 2)
                                    obj[`${n}_max_time`] = this.timeGenerate(extremum[
                                        `${l.subLoopUrl}_${n}`].time)
                                }
                                if (index === 1) {
                                    obj[`${n}_min`] = floatFormat(extremum[
                                        `${l.subLoopUrl}_${n}`].min, 2)
                                    obj[`${n}_min_time`] = this.timeGenerate(extremum[
                                        `${l.subLoopUrl}_${n}`].time)
                                }
                                if (index === 2) {
                                    obj[`${n}_mean`] = floatFormat(extremum[
                                        `${l.subLoopUrl}_${n}`].mean, 2)
                                }
                            } catch (e) {

                            }
                        })

                    })
                    console.log(obj,"obj")
                    return obj
                }) || []
            },
            ids() {
                return this.loops.map(l => l.loopId)
            },
            updatePoints() {
                debugger
                return [this.loops, this.nodes, this.range, this.date, this.nodeDetails]
            },
        },
        watch: {
            diagramStatus(n) {
                if (this.$route.params.name === 'Extremum' && this.$route.params.tag === 'none') {
                    if (n.type === 'excel' && this.tableData.length > 0) {

                        let data = [
                            ['回路名称', '日期'],
                            [null, null],
                            [null, null],
                        ]

                        let map = ['loopName', 'date']

                        let merges = [{
                                s: {
                                    r: 0,
                                    c: 0
                                },
                                e: {
                                    r: 2,
                                    c: 0
                                }
                            },
                            {
                                s: {
                                    r: 0,
                                    c: 1
                                },
                                e: {
                                    r: 2,
                                    c: 1
                                }
                            },
                        ]

                        // 动态添加后面的
                        this.nodeDetails.forEach((nodeInfo, index) => {
                            data[0].push(nodeInfo.label)
                            data[0].push(null)
                            data[0].push(null)
                            data[0].push(null)
                            data[0].push(null)
                            data[1].push('最大值')
                            data[1].push(null)
                            data[1].push('最小值')
                            data[1].push(null)
                            data[1].push('平均值')

                            data[2].push('数值')
                            data[2].push('发生时间')
                            data[2].push('数值')
                            data[2].push('发生时间')
                            data[2].push(null)
                            // 数据映射
                            map.push(nodeInfo.node + "_max")
                            map.push(nodeInfo.node + "_max_time")
                            map.push(nodeInfo.node + "_min")
                            map.push(nodeInfo.node + "_min_time")
                            map.push(nodeInfo.node + "_mean")

                            // 合并单元格
                            merges.push({
                                s: {
                                    r: 0,
                                    c: 2 + 5 * index
                                },
                                e: {
                                    r: 0,
                                    c: 6 + 5 * index
                                }
                            })
                            merges.push({
                                s: {
                                    r: 1,
                                    c: 2 + 5 * index
                                },
                                e: {
                                    r: 1,
                                    c: 3 + 5 * index
                                }
                            })
                            merges.push({
                                s: {
                                    r: 1,
                                    c: 4 + 5 * index
                                },
                                e: {
                                    r: 1,
                                    c: 5 + 5 * index
                                }
                            })
                            merges.push({
                                s: {
                                    r: 1,
                                    c: 6 + 5 * index
                                },
                                e: {
                                    r: 2,
                                    c: 6 + 5 * index
                                }
                            })


                        })
                        // 数据
                        this.tableData.forEach(d => {
                            data.push(map.map(k => d[k]))
                        })
                        exportExcel(data, '电力极值报表', merges)
                    } else {
                        this.$message.warning("无图表数据！")
                    }
                }
            },
            updatePoints(n) {
                this.requestValues()
            },
            loops(n,o){
                if (this.requestRes.length === 0) {
                    return []
                }
                let date = this.range === 'day' ? this.date.toLocaleDateString() : this.date.getFullYear() + '/' + (this
                    .date.getMonth() + 1)
                return this.loops.map(l => {
                    let obj = {
                        loopName: l.loopName,
                        date
                    }

                    this.nodes.forEach(n => {
                        this.requestRes.forEach((res, index) => {
                            try {
                                let extremum = res.data.data.extremum;

                                for (let k in extremum) {
                                    if (extremum.hasOwnProperty(k)) {
                                        var start = k.indexOf("/");
                                        var s = k.substring(start + 1);
                                        extremum[s] = extremum[k]
                                    }
                                }
                                // console.log(extremum)


                                if (index === 0) {
                                    obj[`${n}_max`] = floatFormat(extremum[
                                        `${l.subLoopUrl}_${n}`].max, 2)
                                    obj[`${n}_max_time`] = this.timeGenerate(extremum[
                                        `${l.subLoopUrl}_${n}`].time)
                                }
                                if (index === 1) {
                                    obj[`${n}_min`] = floatFormat(extremum[
                                        `${l.subLoopUrl}_${n}`].min, 2)
                                    obj[`${n}_min_time`] = this.timeGenerate(extremum[
                                        `${l.subLoopUrl}_${n}`].time)
                                }
                                if (index === 2) {
                                    obj[`${n}_mean`] = floatFormat(extremum[
                                        `${l.subLoopUrl}_${n}`].mean, 2)
                                }
                            } catch (e) {

                            }
                        })

                    })
                    console.log(obj,"obj")
                    return obj
                }) || []
            }
        },
        methods: {
            timeGenerate(time) {
                let date = new Date(time);
                if (this.range === 'day') {
                    return dateFormat("HH:MM:SS", date)
                } else {
                    return dateFormat("d日 HH:MM:SS", date)
                }
            },
            async requestValues() {

                this.requestRes = []
                if (this.loops.length === 0 || this.nodes.length === 0) {
                    return
                }
                this.loading = true

                let start
                let end
                if (this.range === 'day') {
                    start = dayStart(this.date)
                    end = dayEnd(this.date)
                } else {
                    start = monthStart(this.date)
                    end = monthEnd(this.date)
                }
                let res = []
                try {
                    res = await Promise.all([
                        EXTREMUM_VALUES(this.ids, this.nodes, "MAX", start, end),
                        EXTREMUM_VALUES(this.ids, this.nodes, "MIN", start, end),
                        EXTREMUM_VALUES(this.ids, this.nodes, "MEAN", start, end),
                    ])
                } catch (e) {

                } finally {
                    console.log(res)
                    this.requestRes = res
                    this.loading = false
                }


            }
        },
        mounted() {
            this.requestValues()
        },


    }
</script>

<style scoped lang="less">
    .tip {
        width: 100%;
        height: 100%;
        font-size: 16rem;
        color: #8c939d;
    }

    .loading {
        width: 28rem;
        height: 28rem;
        animation: loading 1s linear infinite;
    }

    @keyframes loading {
        0% {
            transform: rotate(0);
        }

        100% {
            transform: rotate(360deg);
        }
    }
</style>